import { SubscribedControlStatusById } from '@energybox/react-ui-library/dist/types/SubscribedControlStatus';
import { isDefined } from '@energybox/react-ui-library/dist/utils';
import assocPath from 'ramda/src/assocPath';
import pipe from 'ramda/src/pipe';
import { Actions as StreamActions } from '../actions/streamApi';

const initialState = {
  byCamId: {},
};

const subscribedControlStatus = (
  state: SubscribedControlStatusById = initialState,
  action: any
) => {
  switch (action.type) {
    case StreamActions.RECEIVED_DEVICE_STATUS: {
      if (
        isDefined(action.data) &&
        isDefined(action.data.deviceType) &&
        action.data.deviceType === 'control' &&
        isDefined(action.data.status) &&
        isDefined(action.data.status.workingMode)
      ) {
        const controlStatus = {
          id: action.data.id,
          uuid: action.data.uuid,
          updatedAt: action.data.status.updatedAt,
          timestamp: action.data.status.timestamp,
          unixTimestamp: new Date(action.data.status.timestamp).getTime(),
          healthiness: action.data.status.healthiness,
          workingMode: action.data.status.workingMode,
        };
        return pipe(
          assocPath(['byCamId', action.data.id.toString()], controlStatus)
        )(state);
      }

      return state;
    }

    default:
      return state;
  }
};

export default subscribedControlStatus;
